module.exports = __webpack_public_path__ + "img/icona-ordine-prjweb.271d0bf0.png";